/**
 * Kod wygenerowany automatycznie przez automatyczne narz�dzie (problemy zg�asza� do Tomasza Grze�kiewicza)
 * nie zmieniaj tego pliku, wszystkie zmiany zostan� nadpisane automatycznie
 */
import {Api} from "../index";
import {ReactivityValidator} from "../../utils/ReactivityValidator"

export const Allowance = {

	deleteAllowance (context, userId, allowanceDTO, onSuccess, onError, options) {
		Api.delete(context,
			"/allowance/allowance"
			+ "?userId=" + userId
			, allowanceDTO
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getUserAllowances (context, userId, onSuccess, onError, options) {
		Api.get(context,
			"/allowance/user-allowances"
			+ "?userId=" + userId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putAllowance (context, allowanceDTO, onSuccess, onError, options) {
		Api.put(context,
			"/allowance/allowance"
			, allowanceDTO
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

};
